import styled from "styled-components";

export default styled.div`
border-radius:5px;
  color: #004274;
  margin: 30px 0;
`;